
let React                     = require("react");

let ContentServerClient       = require("../../ContentServerClient.js");

let Toast                     = require("../../controls/Toast.jsx");
let MemberRemoved             = require("../../controls/hub/toast/MemberRemoved.jsx");
let InvitationsToastHub       = require("../../controls/hub/toast/InvitationsToastHub.jsx");
let TransferOwnershipToastHub = require("../../controls/hub/toast/TransferOwnershipToastHub.jsx");
let UndeleteHubToast          = require("../../controls/hub/toast/UndeleteHubToast.jsx");
let HubsUtil                   = require("../../util/HubsUtil.js");

class ToastPage extends React.Component {

    constructor() {
        super()
        this.state = {
            memberRemoved: {show: false},
            invitation: {show: false},
            invitedTo: {show: true, hubs: []},
            undelete: {show: false},
            currentHub: null
        };

        this.listChildrenMethods = {};
        this.listMedia = [1380, 1184, 1024, 928, 828, 720, 620, 572, 500, 420];

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.getInvitedTo = this.getInvitedTo.bind(this);
        this.setCurrentHub = this.setCurrentHub.bind(this);

        this.setHubInfo = this.setHubInfo.bind(this);

        this.resizeToastContainer = this.resizeToastContainer.bind(this);
        this.checkInvitation = this.checkInvitation.bind(this);
        this.childrenMethods = this.childrenMethods.bind(this);
        this.setCanHaveMoreHubs = this.setCanHaveMoreHubs.bind(this);
        this.checkHubsAvailability = this.checkHubsAvailability.bind(this);
    }

    componentDidMount(){
        this.getInvitedTo();
        this.listMedia.forEach(media => window.matchMedia(`(max-width: ${media}px)`).addListener(this.resizeToastContainer));
    }

    componentWillUnmount(){
        this.listMedia.forEach(media => window.matchMedia(`(max-width: ${media}px)`).removeListener(this.resizeToastContainer));
    }

    childrenMethods(parent, methods){
        this.listChildrenMethods = Object.assign(this.listChildrenMethods, {[parent]: methods})
    }

    getInvitedTo(){
        if(this.state.invitedTo.show){
            // dont throw errors from toasts
            ContentServerClient.getInvitedToHub(()=>{})//this.props.handleError
                .then(({hubs}) => this.setState({invitedTo: {show: true, hubs}}))
        }
    }

    onOpen(modal, info = {}){
        this.setState({[modal]: Object.assign({show: true}, info)})
    }

    // what is even happening here...
    onClose(name){
        this.setState(prevState => ({[name]: Object.assign(prevState[name], {show: false})}), this.resizeToastContainer);
    }

    resizeToastContainer(){
        //In order to mock the downward movement we change the container's margin-top, avoid using a react variable because it makes an infinite loop
        document.getElementById("toastContainer").style.marginTop = `${document.querySelector("#toastContainer .cont").clientHeight}px`;
    }

    setHubInfo(currentHub, currentHubMembers, currentHubInvites, search){
        this.onClose("undelete");
        if(search) {
            let invitation = this.checkInvitation(search, currentHub);
            this.setState({invitation})
        }

        if(currentHub){
            this.setState({currentHub})
        }
        if(currentHubMembers){
            this.setState({currentHubMembers})
        }
        if(currentHubInvites){
            this.setState({currentHubInvites})
        }
    }

    setCanHaveMoreHubs(canHaveMoreHubs, isPremiumAccount, totalHubsAllowed){
        this.setState({canHaveMoreHubs, isPremiumAccount, totalHubsAllowed})
    }

    setCurrentHub(currentHub, search){
        this.onClose("undelete");
        let invitation = {show: false};
        if(search) {
            invitation = this.checkInvitation(search, currentHub);
        }
        this.setState({currentHub, invitation})
    }

    checkInvitation(search, currentHub){
        return {
            show: search.includes("state"),
            accepted: search.includes("state=accepted"),
            rejected: search.includes("state=rejected"),
            hubName: search.includes("hubname")? HubsUtil.handleString(search).sliceFrom("hubname="): currentHub.name
        }
    }

    checkHubsAvailability(callBack){
        const { canHaveMoreHubs, isPremiumAccount } = this.state;

        const premiumError = () => { this.props.handleError(null, "accept transfer", "You are at the hub limit.  Must delete one to accept") };
        const subscribeError = () => { if (this.listChildrenMethods && this.listChildrenMethods.hubModalManager) this.listChildrenMethods.hubModalManager.onOpen("subscribe") };

        if (canHaveMoreHubs){
            callBack();
        } else if (isPremiumAccount) {
            premiumError();
        } else if (!isPremiumAccount) {
            //handling the case where user clicks "Yes" on explore page
            if (canHaveMoreHubs === undefined && isPremiumAccount === undefined) return callBack({ premiumError, subscribeError });

            subscribeError();
        }
    }

    render() {
        const { renderPage, setConfirmation } = this.props;

        const {invitedTo, invitation = {show: false}, memberRemoved, currentHub, totalHubsAllowed} = this.state;
        const locked = currentHub && currentHub.owner.locked? currentHub.owner.locked :false;

        return  <React.Fragment>
                    <div id="toastContainer" className="toastContainer" style={{transition: "all .5s"}}>
                        <div className="cont">
                            <TransferOwnershipToastHub resizeToastContainer={this.resizeToastContainer} checkHubsAvailability={this.checkHubsAvailability} {...this.props} onOpen={this.onOpen}/>

                            <InvitationsToastHub invitedTo={invitedTo} {...this.props}/>

                            <Toast resizeToastContainer={this.resizeToastContainer} onClose={this.onClose}
                                show={invitation.show && invitation.accepted} toastName="invitation">
                                <p className="text">Congratulations! You've been successfully added to <span className="bold">{invitation.hubName}</span>.</p>
                            </Toast>

                            <Toast resizeToastContainer={this.resizeToastContainer} onClose={this.onClose}
                                show={invitation.show && invitation.rejected} toastName="invitation" type="warning">
                                <p className="text">You have declined the invitation to join <span className="bold">{decodeURI(invitation.hubName)}</span>.</p>
                            </Toast>

                            <MemberRemoved {...memberRemoved} resizeToastContainer={this.resizeToastContainer} onClose={this.onClose} setConfirmation={setConfirmation}/>

                            <UndeleteHubToast resizeToastContainer={this.resizeToastContainer} onClose={this.onClose} checkHubsAvailability={this.checkHubsAvailability} {...this.props} {...this.state} />

                            {currentHub &&
                                <Toast resizeToastContainer={this.resizeToastContainer} onClose={this.onClose} type="warning" toastName="deleteScheduled" show={locked}>
                                    <p className="text">This {fullHubAlias} is scheduled for deletion. Please contact {currentHub.owner && currentHub.owner.name} ({currentHub.owner && currentHub.owner.email}) with any concerns.</p>
                                </Toast>}
                        </div>
                    </div>

                    { renderPage({
                        onOpen:this.onOpen,
                        onClose:this.onClose,

                        setCurrentHub:this.setCurrentHub,
                        childrenMethods:this.childrenMethods,
                        setCanHaveMoreHubs:this.setCanHaveMoreHubs,

                        totalHubsAllowed: totalHubsAllowed,

                        setHubInfo:this.setHubInfo,
                        currentHub: this.state.currentHub,
                        currentHubMembers: this.state.currentHubMembers,
                        currentHubInvites: this.state.currentHubInvites,

                    })}
                </React.Fragment>
    }
}

module.exports = ToastPage;
